
<app-toast [message]="toast.message"></app-toast>

<div class="row">
  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <app-loading [condition]="isLoading"></app-loading>
    @if (!isLoading) {
      <div class="card">
        <h4 class="card-header">Account settings</h4>
        <div class="card-body">
          <form #editAccountForm="ngForm" (ngSubmit)="save(user)">
            <div class="row">
              <div class="form-group col-lg-5">
                <label>First name <span class="text-danger small">(required)</span></label>
                <input class="form-control" [ngClass]="setClassInvalidTpl(firstName)"
                  type="text" name="First name" #firstName="ngModel"
                  [(ngModel)]="user.firstName" placeholder="First name" required>
              </div>
              <div class="form-group col-lg-5">
                <label>Last name <span class="text-danger small">(required)</span></label>
                <input class="form-control" [ngClass]="setClassInvalidTpl(lastName)"
                  type="text" name="Last name" #lastName="ngModel"
                  [(ngModel)]="user.lastName" placeholder="Last name" required>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-10">
                <label>Email <span class="text-danger small">(required)</span></label>
                <input class="form-control" type="email" name="Email"
                  [(ngModel)]="user.email" placeholder="Email" disabled required>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-5">
                <label>Department <span class="text-danger small">(required)</span></label>
                <select class="form-control" [ngClass]="setClassInvalidTpl(department)"
                  name="department" #department="ngModel" [(ngModel)]="user.department" required>
                  <option value="" selected disabled>Select department</option>
                  @for (department of departments; track department) {
                    <option [value]="department">{{department}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-lg-5">
                <label>Site <span class="text-danger small">(required)</span></label>
                <select class="form-control" [ngClass]="setClassInvalidTpl(site)"
                  name="site" #site="ngModel" [(ngModel)]="user.site" required>
                  <option value="" selected disabled>Select site</option>
                  @for (site of sites; track site) {
                    <option [value]="site">{{site}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-10">
                <label class="me-1">Google Drive personal folder <span class="text-danger small">(required)</span></label>
                <input class="form-control" type="url" name="driveurl" #driveurl="ngModel" [(ngModel)]="user.driveurl" placeholder="https://drive.google.com/drive/folders/abc123" required>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-4 mt-1 mb-0">
                <label class="me-1">Email notifications</label>
              </div>
            </div>
            <div class="row">
              <div class="custom-control custom-switch ms-1 my-1">
                <input type="checkbox" class="custom-control-input cursor-pointer" id="switch-records" name="emailNotificationsRecords"
                  [(ngModel)]="emailNotifications.records" [checked]="emailNotifications.records">
                <label class="custom-control-label cursor-pointer" for="switch-records">
                  Toggle email notifications for new records added with you
                </label>
              </div>
            </div>
            <div class="row">
              <div class="custom-control custom-switch ms-1 my-1">
                <input type="checkbox" class="custom-control-input cursor-pointer" id="switch-comments" name="emailNotificationsComments"
                  [(ngModel)]="emailNotifications.comments" [checked]="emailNotifications.comments">
                <label class="custom-control-label cursor-pointer" for="switch-comments">
                  Toggle email notifications for new comments on records with you
                </label>
              </div>
            </div>
            <button class="btn btn-primary mt-3" type="submit" [disabled]="!editAccountForm.form.valid">
              <i class="fa fa-save"></i> Save
            </button>
          </form>
        </div>
      </div>
    }
  </div>
</div>
